import { render, staticRenderFns } from "./PasswordModifiedAlert.vue?vue&type=template&id=1a5dea51&"
import script from "./PasswordModifiedAlert.vue?vue&type=script&lang=js&"
export * from "./PasswordModifiedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports